// extracted by mini-css-extract-plugin
export default {"searchContainer":"searchContainer--1gXgr","title":"title--34Vtz","searchResults":"searchResults--3dDSE"};